import { useNotificationProvider } from "core/hooks";
import { NotificationProvider } from "core/providers"

export const NotificationProviderSetter = () => {
    NotificationProvider.provider = useNotificationProvider();
    return null;
};